import React, { useState, useEffect, useRef } from 'react';
import './CommercialRoadmap.css';

// ─── Data ────────────────────────────────────────────────────────────────────

const SCORES = [
   { label: 'Product-markt fit',          score: 9,  note: 'EU CRA 2027 maakt SBOM verplicht — timing is perfect, boetes tot €15M zijn de salesargument' },
   { label: 'Feature volledigheid',        score: 9,  note: 'CRA rapport (11 checks) + portfolio CRA dashboards + supplier trust + evidence packs + PURL/CPE enrichment + malware v2 + SLSA MVP + maintainer anomalies + 6-tier reachability + Vigil SAST tab + OIDC/Azure AD SSO + Jira sync ✅ — IaC/SAML-hardening nog open' },
   { label: 'Competitive differentiation', score: 9,  note: 'EU CRA auditrapport + supplier trust + evidence packs + malware detectie v2 + identifier enrichment + maintainer anomalies + reachability MVP onderscheiden DepGuard sterk' },
  { label: 'Go-to-market readiness',      score: 7,  note: 'Pricing pagina ✅ + trial flow ✅ + enterprise demo corpus ✅ — customer website, sales materiaal en commerciële packaging nog open' },
   { label: 'Technical scalability',       score: 5,  note: 'SQLite blokkeert multi-tenant SaaS' },
];

const COMPETITORS = [
  { name: 'Snyk',              tier: 1, price: '€25–98/dev/mnd',   weakness: 'Developer-gericht, niet SBOM-first, duur bij schalen' },
  { name: 'Black Duck',        tier: 1, price: '€50K–200K+/jaar',  weakness: 'Enterprise, complex, langzame implementatie' },
  { name: 'Mend.io',           tier: 1, price: '€20K–80K/jaar',    weakness: 'Overweldigend, CI/CD-gericht' },
  { name: 'FOSSA',             tier: 1, price: '€15K–60K/jaar',    weakness: 'Sterk op licenties, minder op VEX/compliance' },
  { name: 'Dependency-Track',  tier: 2, price: 'Gratis (OSS)',     weakness: 'Zelf-hosten, geen compliance mapping, UX matig' },
  { name: 'Anchore Enterprise',tier: 2, price: '€30K+/jaar',       weakness: 'Sterk in containers, minder in code-SBOMs' },
];

const FEATURE_MATRIX = [
  { feature: 'SBOM upload (SPDX + CDX)',            depguard: true,      dt: true,  snyk: false, bd: true  },
  { feature: 'Vulnerability scanning (OSV/GHSA)',   depguard: true,      dt: true,  snyk: true,  bd: true  },
  { feature: 'Package health (OpenSSF Scorecard)',  depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'SBOM kwaliteitsscore (A–F grade)',    depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'NTIA compliance check',               depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'VEX statements',                      depguard: true,      dt: true,  snyk: false, bd: false },
  { feature: 'Remediation tracking',                depguard: true,      dt: false, snyk: true,  bd: true  },
  { feature: 'Dependency graph',                    depguard: true,      dt: true,  snyk: true,  bd: true  },
  { feature: 'Cross-Project Dependency Impact Graph', depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'Compliance mapping (NIST/ISO/CRA)',   depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'Portfolio compliance matrix',         depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'SBOM Diff',                           depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'AI assistent (multi-provider)',       depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'Abandoned package detection',         depguard: true,      dt: false, snyk: false, bd: false },
  { feature: 'PDF rapport export',                  depguard: true,      dt: false, snyk: false, bd: true  },
  { feature: 'REST API + Swagger UI',               depguard: true,      dt: true,  snyk: true,  bd: true  },
  { feature: 'CI/CD policy gate + wizard',          depguard: true,      dt: true,  snyk: true,  bd: true  },
  { feature: 'JWT Authenticatie + RBAC',            depguard: true,      dt: false, snyk: true,  bd: true  },
  { feature: 'Audit log',                           depguard: true,      dt: false, snyk: true,  bd: true  },
  { feature: 'Webhook alerts (Slack/Teams)',        depguard: true,      dt: false, snyk: true,  bd: true  },
   { feature: 'EU CRA Compliance Report',            depguard: true,      dt: false, snyk: false, bd: false },
    { feature: 'Malware / typosquatting detectie',    depguard: true,      dt: false, snyk: true,  bd: false },
     { feature: 'SLSA provenance verificatie',         depguard: 'partial', dt: false, snyk: false, bd: false },
     { feature: 'Maintainer anomaly detectie',         depguard: true,      dt: false, snyk: true,  bd: false },
     { feature: 'Supplier trust portfolio view',       depguard: true,      dt: false, snyk: false, bd: false },
     { feature: 'Evidence pack export',                depguard: true,      dt: false, snyk: false, bd: false },
     { feature: 'PURL / CPE enrichment',               depguard: true,      dt: true,  snyk: true,  bd: true  },
    { feature: 'IaC / Container SBOM',               depguard: false,     dt: false, snyk: true,  bd: true  },
    { feature: 'Reachability Analysis (VEX auto)',   depguard: 'partial', dt: false, snyk: 'partial', bd: false },
    { feature: 'SSO / SAML / LDAP',                  depguard: 'partial', dt: false, snyk: true,  bd: true  },
    { feature: 'Community Health Intelligence (Bus Factor, BMI, Lead Times, Retention, Growth)', depguard: false, dt: false, snyk: false, bd: false },
    { feature: 'Corporate Backing Analysis (single-vendor risk, org dominance)', depguard: false, dt: false, snyk: false, bd: false },
    { feature: 'Competitive Dependency Analysis (health vs. alternatives)', depguard: false, dt: false, snyk: false, bd: false },
];

const GAPS = {
  done:     [
    { label: 'JWT Authenticatie + RBAC',                     impact: 'Admin/Analyst/Viewer rollen, login, user management' },
    { label: 'Audit log',                                     impact: 'Alle acties gelogd met actor, IP, timestamp' },
     { label: 'GitHub Actions CI/CD wizard',                   impact: '6 ecosystems, workflow download, policy gate ingebakken' },
     { label: 'Webhook / Slack / Teams alerts',                impact: 'Push-notificaties bij kritieke CVE, policy-fail, nieuwe SBOM' },
     { label: 'UX overhaul (Inter, ⌘K, sidebar)',              impact: 'Professional look & feel, keyboard navigatie, collapsible nav' },
      { label: 'Background job queue',                          impact: 'Async SBOM scanning, `/jobs/:id` status polling' },
       { label: 'EU CRA Compliance Report + portfolio score + policy gates',    impact: 'Dedicated CRA audit per SBOM — 11 Article 20 checks incl. licentieverklaringen (Art. 20(1)(f)); formeel 5-sectie HTML auditdocument met EU-vlag, scorecard, voortgangsbalken, bevindingen en attestatieblok; CRA score zichtbaar op dashboard en matrix, enforceable via policy engine en CI/CD gates' },
      { label: 'PURL / CPE enrichment & identifier quality',    impact: 'Conservatieve enrichment + validatie live, CRA/NTIA bruikbaarheid direct zichtbaar in SBOM Quality' },
      { label: 'Malware & typosquatting detectie (v2)',         impact: '5 detectie-algoritmen: Jaro-Winkler, Damerau-Levenshtein, combosquatting, prefix/suffix, Unicode — npm 400+, PyPI 300+, RubyGems, NuGet, Maven uitgebreid — portfolio malware-overzicht' },
      { label: 'SLSA provenance verificatie (MVP)',             impact: 'Attestation upload + digest match + provenance metadata + estimated level zichtbaar in repo-details' },
      { label: 'Maintainer anomaly detectie',                   impact: 'Anomaly scores, severity, package flags, summary cards en dedicated anomalies tab zijn live' },
      { label: 'Reachability Analysis (6-tier pipeline)',       impact: 'Volledige 6-tier pipeline live: static grep (Tier 3), lockfile-depth (Tier 4), Joern Java CPG (Tier 5), Semgrep OWASP-top-10 (Tier 6 — 3 matching-strategieën: CVE ID → CWE → pakket-naam tokens); async 202/jobId-polling UX met 4-stap stepper en live timer; coverage WebGoat 128.4% ✅ NodeGoat 81.6% ✅; 🔴 semgrep tier-badge in ReachabilityView' },
      { label: 'Vigil SAST tab in Repo Details',               impact: 'RepoSastView live onder Code Analysis → SAST sub-tab: scan-geschiedenis, severity summary cards, findings table met filters, re-scan knop; vigil_scans tabel en vigilScanStartHandler live' },
      { label: 'Supplier trust portfolio',                      impact: 'Snapshot-backed overzicht combineert malware, typosquatting, maintainer health, abandoned packages, reachability en SLSA tot één leveranciersrisico-signaal' },
      { label: 'Evidence pack export (v1)',                     impact: 'Per SBOM één ZIP met SBOM, CRA JSON/HTML, remediation, reachability, SLSA, supplier trust, audit log en manifest voor audits en due diligence' },
      { label: 'OIDC / Azure AD enterprise auth (v1)',          impact: 'Enterprise sign-in, admin SSO-config, auto-provisioning en RBAC-bridging zijn live; SAML/LDAP follow-up blijft open' },
      { label: 'Jira remediation sync (v1)',                   impact: 'Admins kunnen Jira configureren; tracked findings kunnen issues openen en ticketstatus terug synchroniseren in DepGuard' },
       { label: 'Cross-Project Dependency Impact Graph',           impact: 'Interactieve force-graph op /impact toont welke projecten worden geraakt door een kwetsbaar pakket — pulserende animatie voor CRITICAL nodes, kleurcodering per ernst, filter op CVE/policy/grade, side-panel per project, tabel/graph weergave-toggle, CSV export' },
       { label: 'CSAF advisory support',                           impact: 'CSAF 2.0 advisories importeren van Microsoft, Red Hat, enz. — twee matching-strategieën: CVE cross-reference + genormaliseerde naam-matching; per-SBOM CSAF-matches tab live' },
      { label: 'Pricing pagina + trial flow',                   impact: 'Commerciële packaging en self-service proefroute zijn zichtbaar in-product' },
   ],
    critical: [
       { label: 'Autonomous AI Security Agent',     impact: '80% minder handmatig werk — agentic triage, VEX, remediation' },
    ],
    high: [
      { label: 'Community Health Intelligence', impact: '7 sociotechnical metrics per dependency (Bus Factor, BMI, REI, Lead Time Issues/PRs, Retention Rate, Active Contributor Growth) — community risk score 0–10 per package, gegroepeerd in 3 categorieën: Demand vs. Capacity (BMI+REI), Response Speed (lead times), Community Sustainability (bus factor, retention, growth). Data via GitHub API.' },
      { label: 'Corporate Backing Analysis', impact: 'Welke organisaties drijven een open-source project? Single-vendor flag (relicensing risk), organisatie-dominantie-score, detectie van corporate exits/entries — direct relevant voor EU CRA due diligence.' },
      { label: 'Competitive Dependency Analysis', impact: 'Als een dependency hoog risico scoort op community health, stel gezondere alternatieven voor die dezelfde functionaliteit bieden. Differentieert DepGuard van alle bestaande SBOM-tools.' },
      { label: 'SAML / LDAP / enterprise identity hardening', impact: 'OIDC/Azure AD v1 is live, maar bredere directory-dekking en enterprise-hardening zijn nog nodig' },
      { label: 'ServiceNow en bredere workflow-integraties', impact: 'Jira v1 is live; grotere enterprise teams willen daarna extra ITSM-koppelingen' },
      { label: 'Customer website + knowledge hub', impact: 'Klantgerichte DepGuard-site met bedrijfsverhaal, productuitleg, documentatie, FAQ en zoekfunctie ontbreekt nog' },
      { label: 'depguard-reach: Reachability hardening', impact: 'MVP live, maar production hardening en bredere multi-language analyzers zijn nog nodig' },
      { label: 'IaC + Container SBOM',             impact: 'Terraform, Helm, Docker — meeste deployments zijn infra-as-code' },
    ],
  medium: [
    { label: 'PostgreSQL optie',                 impact: 'SQLite blokkeert schaalbare SaaS en enterprise deployments' },
    { label: 'Multi-organisatie API isolatie',   impact: 'DB schema bestaat al — volledige tenant isolatie nog open' },
  ],
  gtm: [
    { label: 'EU CRA Practical Guide (priority 1)', impact: '3–4 pagina\'s gericht op EU CRA compliance — "wat vereist de wet, wat moet je SBOM bevatten, hoe bewijs je compliance". Directe salesargument (boetes tot €15M). Downloadbaar als PDF, ingebakken in product als lead-gen asset.' },
    { label: 'DepGuard Whitepaper (priority 2)', impact: '"Beyond CVE Scanning: The Complete OSS Dependency Security Lifecycle" — 15–20 pagina\'s, 8-staps lifecycle (SBOM → CVE → reachability → licenties → SBOM-kwaliteit → project health → remediation → bewijs). Positioneert DepGuard als het enige platform dat alle drie pilaren dekt: security, compliance én project health.' },
    { label: 'One-pager / data sheet (priority 3)', impact: 'Snelste te produceren — destillaat van de whitepaper. Gebruikt in salesgesprekken, e-mailcampagnes en partnerdecks. Kan direct worden gegenereerd vanuit de whitepaperinhoud.' },
    { label: 'Case study: WebGoat / NodeGoat analyse (priority 4)', impact: 'Concreet bewijs — "DepGuard vond X kritieke CVEs, Y licentieproblemen, SBOM-graad D — hier is hoe je het repareert". Bouwt vertrouwen bij technische kopers.' },
    { label: 'Competitor comparison PDF (priority 5)', impact: '"DepGuard vs Snyk vs Black Duck vs Dependency-Track" — buyers vragen hier altijd om. Kan worden gegenereerd vanuit de bestaande FEATURE_MATRIX.' },
  ],
};

const ROADMAP_PHASES = [
  {
    num: 1, status: 'done', label: 'Enterprise-Ready', period: 'Maand 1–2',
    items: [
      { done: true,  text: 'JWT authenticatie + registratie' },
      { done: true,  text: 'RBAC: Admin / Analyst / Viewer' },
      { done: true,  text: 'Audit log (alle acties)' },
      { done: true,  text: 'GitHub Actions CI/CD wizard (6 ecosystems)' },
      { done: true,  text: 'Webhook alerts (Slack, Teams, HTTP + HMAC)' },
      { done: true,  text: 'Background job queue (async scanning)' },
      { done: true,  partial: true, text: 'Multi-org structuur (DB schema ✅, API isolatie nog open)' },
    ],
    outcome: '✅ Enterprise demo mogelijk — auth, RBAC, CI/CD en webhooks zijn live',
  },
  {
     num: 2, status: 'active', label: 'Competitive Differentiation', period: 'Maand 2–4',
      items: [
        { done: true, text: 'EU CRA Compliance Report + CRA policy gates live (11 Article 20 checks incl. licentieverklaringen Art. 20(1)(f); formeel 5-sectie HTML auditdocument; portfolio score + enforceable quality thresholds)' },
        { done: false, planned: true, text: 'Autonomous AI Security Agent (triage, VEX, remediation — geen chat)' },
        { done: true,  text: 'Malware & typosquatting detectie v2 (5 algoritmen + 800+ pakketlijst + portfolio-overzicht)' },
        { done: true, partial: true, text: 'SLSA provenance verificatie MVP live (attestation upload, digest matching, estimated level 1–3; signature trust verification nog open)' },
        { done: true, text: 'Maintainer anomaly detectie live (scores, severity, anomalies tab en portfolio-overzicht)' },
        { done: true, text: 'Supplier trust portfolio live (snapshot-backed score en tier over malware, maintainer health, reachability en provenance)' },
        { done: true, text: 'Evidence pack export v1 live (ZIP met CRA, remediation, SLSA, reachability, supplier trust en audit-artifacts)' },
      ],
       outcome: 'CRA auditrapportage, supplier trust, evidence packs, malware detectie, SLSA MVP, maintainer anomalies en portfolio compliance zijn live — sterke basis voor enterprise productdemo\'s',
    },
  {
     num: 3, status: 'upcoming', label: 'Enterprise Integraties', period: 'Maand 4–6',
     items: [
        { done: true, partial: true, text: 'OIDC / Azure AD SSO v1 live (provider discovery, callback flow, admin config); SAML/LDAP follow-up nog open' },
       { done: true, partial: true, text: 'Jira v1 live vanuit remediation (admin config, create issue, sync status); ServiceNow follow-up nog open' },
       { done: true, partial: true, text: 'depguard-reach: Volledige 6-tier reachability live (static grep + lockfile-depth + Joern Java CPG + Semgrep OWASP-top-10); async 202/jobId-polling UX; WebGoat 128.4% ✅ NodeGoat 81.6% ✅; productie-hardening nog open' },
       { done: true, text: 'Vigil SAST tab live in Repo Details (Code Analysis → SAST sub-tab; scan-geschiedenis, severity cards, findings table met filters, re-scan)' },
       { done: true, text: 'Maintainer anomaly detectie (hijack signals) live' },
       { done: true, partial: true, text: 'PURL / CPE enrichment & validatie live (conservatieve inference + identifier quality + CRA-aware policy gating)' },
       { done: false, text: 'IaC + Container SBOM (Terraform, Helm, Docker)' },
       { done: false, text: 'Community Health Intelligence — 7 sociotechnical metrics per dependency: Bus Factor, BMI, REI, Median Lead Times, Retention Rate, Growth of Active Contributors (3 groepen: Demand vs. Capacity · Response Speed · Community Sustainability)' },
       { done: false, text: 'Corporate Backing Analysis — single-vendor flag + org-dominantie per dependency voor EU CRA due diligence' },
        { done: true,  text: 'Cross-Project Dependency Impact Graph — interactieve force-graph (D3 + react-force-graph) die packages verbindt aan alle projecten die ze gebruiken; gefilterd op CVE-ernst, licentieklasse, health-score; blast-radius kaart voor enterprise teams met duizenden repo\'s; WOW-UX met geanimeerde risicolabels en side-panel per getroffen project' },
     ],
      outcome: 'Enterprise-adoptie komt dichterbij — reachability hardening, infra-SBOM, community health intelligence, ServiceNow en bredere identity-dekking zijn de volgende grote blokken',
    },
  {
    num: 4, status: 'upcoming', label: 'Schaalbare Architectuur', period: 'Maand 5–7',
    items: [
      { done: false, text: 'PostgreSQL als database optie' },
      { done: false, text: 'Multi-tenant SaaS architectuur (volledige org isolatie)' },
      { done: true,  text: 'CSAF advisory support (vendor advisories) — CSAF 2.0 import + matching live' },
      { done: false, text: 'Rate limiting + API caching' },
    ],
    outcome: 'SaaS product lanceerbaar — 100+ organisaties',
  },
  {
    num: 5, status: 'upcoming', label: 'Go-to-Market', period: 'Maand 6–8',
    items: [
      { done: false, text: 'Open Core: Community vs Enterprise' },
      { done: true, text: 'Pricing pagina + self-service trial ✅' },
      { done: false, text: 'Customer website + searchable knowledge hub (bedrijf, product, docs, FAQ, use cases)' },
      { done: false, text: 'Content strategie — EU CRA Practical Guide (1e prioriteit: 3–4 pag., directe salesargument boetes €15M), DepGuard Whitepaper "Beyond CVE Scanning" (2e prioriteit: 15–20 pag., thought leadership), One-pager/datasheet (3e prioriteit), Case studies + Competitor comparison PDF' },
      { done: false, text: 'Product Hunt + HN Show HN launch' },
      { done: false, text: 'Eerste 5 betalende pilots' },
    ],
    outcome: 'Eerste recurring revenue — validatie product-markt fit',
  },
];

const PRICING_TIERS = [
  {
    name: 'Community',
    price: 'Gratis',
    sub: 'Self-hosted · Open source',
    highlight: false,
    features: ['1–5 repositories', 'Vulnerability scanning', 'SBOM upload + diff', 'REST API', 'Community support'],
  },
  {
    name: 'Starter',
    price: '€49',
    sub: '/maand',
    highlight: false,
    features: ['25 repositories', 'Alle analyse features', 'PDF rapporten', 'AI assistent', 'Webhook alerts', 'Email support'],
  },
  {
    name: 'Professional',
    price: '€249',
    sub: '/maand',
    highlight: true,
    features: ['Unlimited repositories', 'EU CRA Compliance Report', 'Supplier trust portfolio', 'Evidence pack export', 'NIST / ISO 27001 / CRA mapping', 'RBAC multi-user', 'Jira remediation sync (v1)', 'SLA 99.9%', 'Priority support'],
  },
  {
    name: 'Enterprise',
    price: 'Op aanvraag',
    sub: '',
    highlight: false,
       features: ['On-premise optie', 'SSO / SAML / LDAP', 'Autonomous AI Security Agent (roadmap)', 'Advanced SLSA provenance trust verification', 'Malware detectie v2 (5 algoritmen)', 'depguard-reach Reachability + auto-VEX', 'Audit log', 'Custom policies', 'Dedicated CSM', 'SLA 99.99%'],
  },
];

// ─── SVG Arc Gauge ────────────────────────────────────────────────────────────

function ArcGauge({ score, size = 110 }) {
  const r = 38;
  const cx = 50, cy = 54;
  // 270° arc from 225° to 135° (going clockwise through top)
  const startAngle = 225;
  const totalDeg   = 270;
  const arcLen     = (totalDeg / 360) * 2 * Math.PI * r; // ≈ 179.07

  const toRad = (deg) => (deg * Math.PI) / 180;
  const sx = cx + r * Math.cos(toRad(startAngle));
  const sy = cy + r * Math.sin(toRad(startAngle));
  const ex = cx + r * Math.cos(toRad(startAngle + totalDeg));
  const ey = cy + r * Math.sin(toRad(startAngle + totalDeg));

  const color = score >= 7 ? '#10b981' : score >= 5 ? '#3b82f6' : score >= 3 ? '#f59e0b' : '#ef4444';

  const fillLen = arcLen * (score / 10);

  return (
    <svg width={size} height={size * 0.85} viewBox="0 0 100 88" style={{ overflow: 'visible' }}>
      {/* Track */}
      <path
        d={`M ${sx.toFixed(2)},${sy.toFixed(2)} A ${r},${r} 0 1,1 ${ex.toFixed(2)},${ey.toFixed(2)}`}
        fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="7" strokeLinecap="round"
      />
      {/* Fill */}
      <path
        d={`M ${sx.toFixed(2)},${sy.toFixed(2)} A ${r},${r} 0 1,1 ${ex.toFixed(2)},${ey.toFixed(2)}`}
        fill="none" stroke={color} strokeWidth="7" strokeLinecap="round"
        strokeDasharray={`${fillLen.toFixed(2)} ${arcLen.toFixed(2)}`}
        strokeDashoffset="0"
        style={{ filter: `drop-shadow(0 0 5px ${color}80)`, transition: 'stroke-dasharray 1.2s cubic-bezier(0.23,1,0.32,1)' }}
      />
      <text x="50" y="57" textAnchor="middle" fontSize="20" fontWeight="800" fill="currentColor">{score}</text>
      <text x="50" y="70" textAnchor="middle" fontSize="9" fill="var(--rm-muted, #94a3b8)">/10</text>
    </svg>
  );
}

// ─── Score bar with animated fill ────────────────────────────────────────────

function ScoreBar({ score, animate }) {
  const color = score >= 7 ? '#10b981' : score >= 5 ? '#3b82f6' : score >= 3 ? '#f59e0b' : '#ef4444';
  const fill = animate ? `${score * 10}%` : '0%';
  return (
    <div className="rm-score-track">
      <div className="rm-score-fill" style={{ width: fill, background: color }} />
    </div>
  );
}

// ─── Feature check cell ───────────────────────────────────────────────────────

function FCheck({ val }) {
  if (val === true)  return <span style={{ color: '#10b981', fontWeight: 700 }}>✓</span>;
  if (val === false) return <span style={{ color: 'var(--rm-muted)', fontSize: '0.9rem', opacity: 0.5 }}>–</span>;
  return <span style={{ color: '#3b82f6' }} title="Gedeeltelijk">◉</span>;
}

// ─── PACE Methodology Data ────────────────────────────────────────────────────

const PACE_PHASES = [
  {
    num: 1,
    id: 'discover',
    label: 'Discover',
    sub: 'Customer opportunity definition',
    icon: '🔭',
    status: 'done',
    period: 'Q3 2024',
    description: 'Verkennen van de bredere context en het identificeren van de kansruimte die de basis vormt voor DepGuard.',
    questions: [
      'Welke macro-trends drijven de SBOM-markt?',
      'Wie zijn de meest kansrijke klantpersona\'s?',
      'Wat doen bestaande spelers (Snyk, Black Duck) niet goed?',
    ],
    keyLearnings: [
      'EU CRA 2027 maakt SBOM-compliance verplicht — boetes tot €15M creëren urgentie',
      'US EO 14028 stimuleert wereldwijde adoptie stroomafwaarts',
      'Log4Shell / XZ Utils / Polyfill.js: CISO-budget is vrijgemaakt, boardroom vraagt actie',
      'TAM: $6–9 miljard in 2027 — markt groeit sneller dan bredere security sector',
      'Grote concurrenten zijn te duur of te complex voor mid-market (Black Duck: €50–200K/jaar)',
    ],
    exitCriteria: 'Geprioriteerde lijst van kansen, bedreigingen en initiële klant­segmenten + riskiest hypotheses voor volgende fase',
    exitMet: true,
    canvas: ['Vision Canvas', 'Environment Map Canvas'],
    assumptions: [
      { text: 'EU CRA creëert directe compliance-druk bij mid-market software bedrijven', validated: true },
      { text: 'Bestaande tools zijn te complex of te duur voor deze doelgroep', validated: true },
      { text: 'Mid-market heeft budget vrijgemaakt na publieke supply chain incidenten', validated: true },
    ],
  },
  {
    num: 2,
    id: 'problem_fit',
    label: 'Problem Fit',
    sub: 'Problem definition for customer segment',
    icon: '🎯',
    status: 'done',
    period: 'Q4 2024',
    description: 'Valideren dat het probleem reëel is, significant genoeg om op te lossen, en dat wij het juiste segment serveren.',
    questions: [
      'Welke pijn ervaren compliance teams concreet bij SBOM-management?',
      'Begrijpen developers het risico van open source afhankelijkheden?',
      'Wat is de huidige werkwijze en waar loopt het vast?',
    ],
    keyLearnings: [
      'Compliance teams besteden gemiddeld 2–4 uur per audit aan handmatig SBOM-werk',
      'NTIA minimum elements worden zelden volledig gedekt door bestaande SBOMs',
      'Developers willen niet nóg een security tool — integratie met CI/CD is dealbreaker',
      'VEX-statements worden gevraagd door enterprise inkopers maar zelden aangeboden',
      'Segment met beste fit: mid-market software bedrijven onder ISO27001 of CRA-druk',
    ],
    exitCriteria: 'Gevalideerd klantprobleem — >40% van doelsegment erkent significant pijn/gain',
    exitMet: true,
    canvas: ['Persona Canvas', 'Value Proposition Canvas', 'Customer Journey Canvas'],
    assumptions: [
      { text: 'SBOM-kwaliteitsscoring is waardevoller dan alleen vulnerability scanning', validated: true },
      { text: 'CRA compliance rapportage is de primaire koopbeslissing in regulated industries', validated: true },
      { text: 'Teams willen self-service onboarding, niet maanden implementatie', validated: true },
      { text: 'Developers accepteren security tooling mits het in hun bestaande workflow past', validated: true },
    ],
  },
  {
    num: 3,
    id: 'solution_fit',
    label: 'Solution Fit',
    sub: 'Solution response for customer problem',
    icon: '🔬',
    status: 'active',
    period: 'Q1–Q2 2025',
    description: 'Bouwen en valideren van de oplossing die het klantprobleem het beste oplost — itereren naar de MVP die klanten willen.',
    questions: [
      'Welke features zijn essentieel vs nice-to-have voor CRA-compliance klanten?',
      'Is de "van SBOM naar audit-bewijs in 10 minuten" belofte haalbaar?',
      'Betalen klanten voor een Professional tier naast een gratis Community versie?',
      'Willen klanten SBOM + code-reachability in één platform, of hebben ze al Semgrep/SonarQube?',
    ],
    keyLearnings: [
      'EU CRA Compliance Report + evidence pack = de killer feature voor procurement beslissingen',
      'AI assistent versnelt onboarding maar is geen koopbeslissing op zichzelf',
      'RBAC + audit log is blockerend voor enterprise deals — zonder dit geen go',
      'Supplier trust portfolio onderscheidt DepGuard sterk van punt-oplossingen',
      'Open Core (Community gratis, Pro betaald) is het juiste model voor adoptie én revenue',
      'Vigil + Joern CPG = technische basis voor reachability: welke CVE is daadwerkelijk aanroepbaar in de code?',
      'Kritieke vraag open: willen klanten een unified SBOM+SAST platform of bestaande tools behouden?',
    ],
    exitCriteria: 'Gevalideerde oplossing — >40% zou "very disappointed" zijn zonder DepGuard',
    exitMet: false,
    canvas: ['Value Proposition Canvas', 'Business Model Canvas', 'Experimentation Canvas'],
    assumptions: [
      { text: '10-minuten demo sluit enterprise deals bij compliance teams', validated: true },
      { text: 'Evidence pack export is de doorslaggevende feature voor procurement sign-off', validated: null },
      { text: 'Klanten zijn bereid €249/maand te betalen voor Professional tier', validated: null },
      { text: 'Open Core model genereert voldoende GitHub adoptie voor inbound leads', validated: null },
      { text: 'Klanten verkiezen unified SBOM+reachability boven apart SAST-tool (Persevere Vigil)', validated: null },
      { text: 'CWE→Vigil-rule mapping reduceert CVE-ruis met >60% (Tier 2 reachability werkt)', validated: null },
    ],
    currentExperiment: {
      hypothesis: 'Mid-market software bedrijven zijn bereid te betalen voor DepGuard Professional als de ROI vanuit EU CRA-boetes aantoonbaar is én reachability aantoont welke CVEs écht risicovol zijn.',
      method: 'Demo campagne gericht op compliance teams + LinkedIn thought leadership serie over EU CRA + Vigil reachability demo (CWE-89 CVE → Vigil SQL-injectieregels → 3 écht-aanroepbare findings)',
      metric: 'Conversie van demo naar betaald pilot (target: 5 pilots in M4); secundair: klant vermeldt reachability als reden',
      status: 'running',
    },
  },
  {
    num: 4,
    id: 'market_fit',
    label: 'Market Fit',
    sub: 'Business potential validation',
    icon: '📈',
    status: 'upcoming',
    period: 'Q2–Q3 2025',
    description: 'Iteratief lanceren naar een beperkt publiek (Friends & Family) en valideren of het businessmodel schaalbaar is.',
    questions: [
      'Behouden we >40% van klanten maand-op-maand?',
      'Is het businessmodel herhaalbaar en schaalbaar?',
      'Welke kanalen genereren de beste customer acquisition cost?',
    ],
    keyLearnings: [],
    exitCriteria: 'Validated MVP & market — klant hergebruikt en beveelt aan aan anderen; >40% maandretentie',
    exitMet: false,
    canvas: ['Business Model Canvas', 'Service Blueprint Canvas', 'Experimentation Canvas'],
    assumptions: [
      { text: 'Product Hunt + Show HN launch genereert 500+ GitHub stars in M3', validated: null },
      { text: 'Case studies van early adopters verkorten de salescyclus', validated: null },
      { text: 'PostgreSQL migratie is nodig vóór SaaS scale-up', validated: null },
      { text: 'Multi-tenant architectuur is prereq voor eerste 10 enterprise klanten', validated: null },
    ],
    plannedExperiments: [
      'Friends & Family pilot: eerste 10 klanten tegen early adopter prijs (€99/mnd)',
      'LinkedIn EU CRA thought leadership serie — 6 posts over 6 weken',
      'Product Hunt launch met ING PACE als validation framework',
      'A/B test: jaarcontract vs maandabonnement op conversie',
    ],
  },
  {
    num: 5,
    id: 'scaling',
    label: 'Scaling',
    sub: 'Search potential for growth',
    icon: '🚀',
    status: 'upcoming',
    period: 'Q4 2025+',
    description: 'Bepalen van de snelste en meest efficiënte manier om de gevalideerde markt te penetreren en commercialiseren.',
    questions: [
      'Hoe schaalbaar is het businessmodel richting 100+ organisaties?',
      'Welke groeikanalen werken het best (PLG, direct sales, resellers)?',
      'Wanneer is het juiste moment voor externe funding?',
    ],
    keyLearnings: [],
    exitCriteria: 'Geïmplementeerd product met gevalideerde groei — winstgevend, schaalbaar businessmodel met geoptimaliseerde conversie',
    exitMet: false,
    canvas: ['Business Model Canvas', 'Service Blueprint Canvas'],
    assumptions: [
      { text: 'System integrators / consultants als resellers versnellen schaling zonder direct sales', validated: null },
      { text: 'Open Core community wordt self-sustaining na 1000+ GitHub stars', validated: null },
      { text: 'EU CRA deadline (2027) creëert urgentie die GTM versnelt', validated: null },
    ],
    plannedExperiments: [
      'Reseller partnership programme met 2–3 Europese security consultants',
      'Open Core GitHub launch — community-first voor viraal bereik',
      'Enterprise outbound: rechtstreekse benadering regulated industries (finance, healthcare)',
    ],
  },
];

const PACE_LENSES = [
  {
    id: 'desirable',
    icon: '💚',
    label: 'Desirable',
    sub: 'Design Thinking',
    color: '#10b981',
    desc: 'Is het product aantrekkelijk voor de klant? Lossen we een echt probleem op?',
    depguard: [
      'EU CRA deadline creëert urgente pijn — timing is niet optioneel',
      'Mid-market heeft budget maar geen tool op maat',
      'Bewezen via: SBOM kwaliteitsscore, CRA auditrapport, supplier trust',
      'Openstaand: klantinterviews om >40% PMF te bevestigen',
    ],
    score: 8,
  },
  {
    id: 'feasible',
    icon: '🔵',
    label: 'Feasible',
    sub: 'Agile Scrum',
    color: '#3b82f6',
    desc: 'Is het technisch en organisatorisch uitvoerbaar met de beschikbare middelen?',
    depguard: [
      'Go + React + SQLite stack: snel, portable, weinig overhead',
      '25+ features live — bewijs van technische uitvoerbaarheid',
      'Vigil rule engine + Joern CPG + Semgrep: 6-tier reachability pipeline live (static grep → lockfile-depth → Joern Java CPG → Semgrep OWASP-top-10)',
      'Blokkade: PostgreSQL + multi-tenant voor SaaS scale-up',
    ],
    score: 8,
  },
  {
    id: 'viable',
    icon: '🟡',
    label: 'Viable',
    sub: 'Lean Startup',
    color: '#f59e0b',
    desc: 'Is er een businessmodel dat winstgevend en schaalbaar is?',
    depguard: [
      'Open Core: Community (gratis) + Professional (€249/mnd) + Enterprise (custom)',
      'TAM: $6–9B in 2027 — klein marktaandeel = significant revenue',
      'Early adopter deal: €99/mnd voor eerste 10 klanten',
      'Openstaand: eerste MRR valideren (doel M6: €5K MRR)',
    ],
    score: 6,
  },
];

const PACE_EXPERIMENT_LOOP = [
  { step: 1, icon: '👤', label: 'Kies Focus Klant', desc: 'Mid-market software bedrijven (50–500 devs) onder EU CRA / ISO27001 druk — die al een CVE-lijst hebben maar niet weten welke te prioriteren' },
  { step: 2, icon: '⚠️', label: 'Riskiest Assumption', desc: '(A) Klanten betalen €249/mnd als CRA-boete ROI aantoonbaar is · (B) Klanten willen reachability in DepGuard ipv bestaand SAST-tool — dit is de Vigil PACE-beslissing' },
  { step: 3, icon: '🧪', label: 'Ontwerp Experiment', desc: 'Demo met CWE-89 CVE: toon 847 CVEs → Vigil Tier-2 mapping → 12 daadwerkelijk aanroepbare → klant reageert op "welke fix nu?" · Meten: noemt klant reachability als reden voor deal?' },
  { step: 4, icon: '📊', label: 'Voer Uit & Meet', desc: 'Demo-to-paid conversie · NPS na eerste maand · % klanten die Vigil/Rule Studio actief gebruiken · tijd-tot-eerste-fix (target: <30 min na onboarding)' },
  { step: 5, icon: '🧭', label: 'Evidence-based Besluit', desc: 'Persevere Vigil (klant noemt reachability als reden) · Pivot naar reachability-only (geen full SAST vervanging) · Stop Vigil als standalone (Rule Studio blijft intern tooling)' },
];

// ─── Main component ───────────────────────────────────────────────────────────

const TABS = [
  { id: 'analysis',    icon: '📊', label: 'Marktanalyse' },
  { id: 'competitors', icon: '⚔️', label: 'Concurrentie' },
  { id: 'gaps',        icon: '🎯', label: 'Gaps & Status' },
  { id: 'roadmap',     icon: '🗺️', label: 'Roadmap' },
  { id: 'pricing',     icon: '💶', label: 'Pricing' },
  { id: 'strategy',    icon: '🚀', label: 'Strategie' },
  { id: 'pace',        icon: '🔬', label: 'PACE' },
  { id: 'ux',          icon: '🎨', label: 'Look & Feel' },
];

export default function CommercialRoadmap() {
  const [tab, setTab] = useState('analysis');
  const [animated, setAnimated] = useState(false);
  const scoreRef = useRef(null);

  // Trigger bar animation when score section becomes visible
  useEffect(() => {
    if (tab !== 'analysis') return;
    const timer = setTimeout(() => setAnimated(true), 100);
    return () => clearTimeout(timer);
  }, [tab]);

  const avg = Math.round(SCORES.reduce((a, s) => a + s.score, 0) / SCORES.length * 10) / 10;
  const liveFeatureCount = FEATURE_MATRIX.filter((row) => row.depguard === true || row.depguard === 'partial').length;

  return (
    <div className="App-body rm-root">

      {/* ── Hero header ── */}
      <div className="rm-hero">
        <div className="rm-hero-grid">
          <div>
            <div className="rm-hero-tag">🔒 Intern strategisch document · v2.1</div>

            <h1 className="rm-hero-title">🛡️ DepGuard — Commerciële Roadmap</h1>
            <p className="rm-hero-sub">
              Strategische analyse, concurrentiekaart en implementatieplan om van DepGuard
              een commercieel product te maken dat enterprise-klanten aantrekken.
            </p>
            <div className="rm-hero-stats">
              <div className="rm-stat-item">
                <span className="rm-stat-val" style={{ color: '#10b981' }}>€9B</span>
                <span className="rm-stat-label">TAM 2027</span>
              </div>
              <div className="rm-stat-item">
                <span className="rm-stat-val">{liveFeatureCount}</span>
                <span className="rm-stat-label">Live / partial features</span>
              </div>
              <div className="rm-stat-item">
                <span className="rm-stat-val">5</span>
                <span className="rm-stat-label">Roadmap fases</span>
              </div>
              <div className="rm-stat-item">
                <span className="rm-stat-val" style={{ color: '#3b82f6' }}>Fase 3</span>
                <span className="rm-stat-label">PACE Solution Fit</span>
              </div>
              <div className="rm-stat-item">
                <span className="rm-stat-val">6mnd</span>
                <span className="rm-stat-label">Launch target</span>
              </div>
              <div className="rm-stat-item">
                <span className="rm-stat-val" style={{ color: '#f59e0b' }}>
                  {new Date().toLocaleDateString('nl-NL', { month: 'short', year: 'numeric' })}
                </span>
                <span className="rm-stat-label">Bijgewerkt</span>
              </div>
            </div>
          </div>

          {/* Overall score gauge */}
          <div className="rm-gauge-wrap">
            <ArcGauge score={avg} size={120} />
            <div className="rm-gauge-label">Commerciële score</div>
          </div>
        </div>
      </div>

      {/* ── Verdict banner ── */}
      <div className="rm-verdict">
        <div className="rm-verdict-score">{avg}<span>/10</span></div>
        <div>
          <div className="rm-verdict-title">
            Sterke kansen — timing is perfect, meerdere enterprise-differentiators zijn nu echt live in plaats van alleen gepland
          </div>
          <div className="rm-verdict-text">
            EU CRA 2027 maakt SBOM-compliance verplicht voor alle EU-marktdeelnemers (boetes tot €15M).
            DepGuard combineert nu EU CRA rapportage, supplier trust, evidence packs, malware detectie v2, SLSA provenance MVP, maintainer anomaly detectie, identifier enrichment, reachability MVP en een eerste OIDC/Azure AD enterprise-auth slice in één platform.
            De grootste commerciële blokkades zitten nu vooral in PostgreSQL/multi-tenant hardening, bredere identity-dekking (SAML/LDAP), ServiceNow/verdere workflow-integraties en verdere productisering — niet meer in de basisworkflow.
          </div>
        </div>
      </div>

      {/* ── Tab navigation ── */}
      <div className="rm-tabs">
        {TABS.map(t => (
          <button
            key={t.id}
            className={`rm-tab${tab === t.id ? ' active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>

      {/* ════════════════════════════════════════════════════════════
          Tab: Marktanalyse
      ════════════════════════════════════════════════════════════ */}
      {tab === 'analysis' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">📈 Marktdrijfkrachten</div>
            <p className="rm-section-desc">Vier macro-trends die de SBOM-markt forceren — en DepGuard's timing perfect maken.</p>
          </div>

          <div className="rm-card-grid" style={{ marginBottom: 32 }}>
            {[
              { icon: '🇪🇺', title: 'EU Cyber Resilience Act', sub: 'Effectief 2027', text: 'Verplicht SBOM + vulnerability handling voor alle EU-producten. Boetes tot €15M of 2.5% wereldwijde omzet.', tag: 'rm-tag-red', tagLabel: 'Hoog' },
              { icon: '🇺🇸', title: 'US Executive Order 14028', sub: '2021 — actief', text: 'SBOM verplicht voor alle software geleverd aan de US overheid. Stimuleert wereldwijde adoptie downstream.', tag: 'rm-tag-blue', tagLabel: 'Actief' },
              { icon: '💥', title: 'Log4Shell · XZ Utils · Polyfill.js', sub: 'Supply chain aanvallen', text: 'Publiek bewustzijn ongekend hoog. CISO\'s hebben budget vrijgemaakt. Boardroom vraagt nu om supply chain visibility.', tag: 'rm-tag-amber', tagLabel: 'Katalysator' },
              { icon: '💰', title: 'TAM: $6–9 miljard', sub: 'Gartner schatting 2027', text: 'SBOM/SCA groeit sneller dan de bredere security markt. Ideale timing — vroeg genoeg om positie te claimen.', tag: 'rm-tag-green', tagLabel: 'Kans' },
            ].map(c => (
              <div key={c.title} className="rm-card">
                <div className="rm-card-icon-row">
                  <span className="rm-card-icon">{c.icon}</span>
                  <div>
                    <div className="rm-card-title">{c.title}</div>
                    <div className="rm-card-sub">{c.sub}</div>
                  </div>
                </div>
                <p className="rm-card-body">{c.text}</p>
                <span className={`rm-tag ${c.tag}`}>{c.tagLabel}</span>
              </div>
            ))}
          </div>

          <div className="rm-divider" />

          <div className="rm-section-intro" ref={scoreRef}>
            <div className="rm-section-heading">📊 Commerciële scores per dimensie</div>
            <p className="rm-section-desc">Eerlijke zelfevaluatie op de vijf dimensies die bepalen of een product commercieel levensvatbaar is.</p>
          </div>

          <div className="rm-card" style={{ marginBottom: 28 }}>
            <div className="rm-scores-list">
              {SCORES.map(s => {
                const color = s.score >= 7 ? '#10b981' : s.score >= 5 ? '#3b82f6' : s.score >= 3 ? '#f59e0b' : '#ef4444';
                return (
                  <div key={s.label} className="rm-score-row">
                    <div>
                      <div className="rm-score-name">{s.label}</div>
                      <div className="rm-score-note">{s.note}</div>
                    </div>
                    <ScoreBar score={s.score} animate={animated} />
                    <div className="rm-score-num" style={{ color }}>{s.score}</div>
                  </div>
                );
              })}
              <div className="rm-divider" style={{ margin: '8px 0' }} />
              <div className="rm-score-row">
                <div>
                  <div className="rm-score-name" style={{ fontWeight: 800 }}>Gemiddelde score</div>
                  <div className="rm-score-note">Gewogen over 5 dimensies</div>
                </div>
                <ScoreBar score={avg} animate={animated} />
                <div className="rm-score-num" style={{ color: '#10b981', fontSize: '1.3rem' }}>{avg}</div>
              </div>
            </div>
          </div>

          <div className="rm-divider" />

          <div className="rm-section-intro">
            <div className="rm-section-heading">🎯 Primaire doelgroepen</div>
            <p className="rm-section-desc">Vier klantsegmenten — gerankt op deal-velocity en betalingsbereidheid.</p>
          </div>

          <div className="rm-card-grid">
            {[
              { icon: '🏢', title: 'Mid-market software bedrijven', sub: '50–500 devs', text: 'Compliance druk (EU CRA, klantaudits, ISO27001). Te klein voor Black Duck, te groot voor handmatig. Budget: €5K–€30K/jaar.', tag: 'rm-tag-green', tagLabel: 'Best fit nu' },
              { icon: '🔧', title: 'System Integrators & Consultants', sub: 'Reseller model', text: 'Bieden DepGuard aan als onderdeel van security assessments. White-label kansen. Snelle schaling zonder direct sales.', tag: 'rm-tag-blue', tagLabel: 'Multiplier' },
              { icon: '🏦', title: 'Regulated industries', sub: 'Finance · healthcare · overheid', text: 'SBOM wettelijk verplicht, niet optioneel. Budget al vrijgemaakt na CRA/NIS2. Langere salescyclus, hogere LTV.', tag: 'rm-tag-purple', tagLabel: 'Hoge waarde' },
              { icon: '🔌', title: 'Embedded / IoT bedrijven', sub: 'Automotive · industrie', text: 'EU CRA raakt hen het hardst (hardware + software bundle). Weinig tools voor hun ecosysteem.', tag: 'rm-tag-amber', tagLabel: 'Emerging' },
            ].map(g => (
              <div key={g.title} className="rm-card">
                <div className="rm-card-icon-row">
                  <span className="rm-card-icon">{g.icon}</span>
                  <div>
                    <div className="rm-card-title">{g.title}</div>
                    <div className="rm-card-sub">{g.sub}</div>
                  </div>
                </div>
                <p className="rm-card-body">{g.text}</p>
                <span className={`rm-tag ${g.tag}`}>{g.tagLabel}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: Concurrentie
      ════════════════════════════════════════════════════════════ */}
      {tab === 'competitors' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">⚔️ Concurrentenkaart</div>
            <p className="rm-section-desc">Zes directe concurrenten — en waarom DepGuard een unieke positie inneemt in elke confrontatie.</p>
          </div>

          <div className="rm-card" style={{ marginBottom: 28, padding: 0, overflow: 'hidden' }}>
            <table className="rm-comp-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Tier</th>
                  <th>Prijs</th>
                  <th>Zwakte vs DepGuard</th>
                </tr>
              </thead>
              <tbody>
                {COMPETITORS.map(c => (
                  <tr key={c.name}>
                    <td style={{ fontWeight: 700 }}>{c.name}</td>
                    <td>
                      <span className={c.tier === 1 ? 'rm-tier-badge rm-tier-1' : 'rm-tier-badge rm-tier-2'}>
                        Tier {c.tier}
                      </span>
                    </td>
                    <td style={{ fontFamily: 'monospace', fontSize: '0.82rem', color: 'var(--rm-muted)' }}>{c.price}</td>
                    <td style={{ fontSize: '0.82rem', color: 'var(--rm-muted)' }}>{c.weakness}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="rm-section-intro">
            <div className="rm-section-heading">🆚 Feature vergelijking</div>
            <p className="rm-section-desc">
              Rijen met <span style={{ background: '#3b82f620', color: '#3b82f6', padding: '1px 6px', borderRadius: 4, fontSize: '0.78rem', fontWeight: 700 }}>UNIEK</span> badge = features die alleen DepGuard biedt.
            </p>
          </div>

          <div className="rm-matrix">
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', width: '40%' }}>Feature</th>
                  <th className="rm-dg-col">🛡️ DepGuard</th>
                  <th>Dep-Track</th>
                  <th>Snyk</th>
                  <th>Black Duck</th>
                </tr>
              </thead>
              <tbody>
                {FEATURE_MATRIX.map(row => {
                  const isUnique = row.depguard === true && !row.dt && !row.snyk && !row.bd;
                  return (
                    <tr key={row.feature} className={isUnique ? 'rm-unique' : ''}>
                      <td>
                        {isUnique && <span className="rm-unique-badge">UNIEK</span>}
                        <span style={{ fontSize: '0.83rem' }}>{row.feature}</span>
                      </td>
                      <td className="rm-dg-col"><FCheck val={row.depguard} /></td>
                      <td><FCheck val={row.dt} /></td>
                      <td><FCheck val={row.snyk} /></td>
                      <td><FCheck val={row.bd} /></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: '0.75rem', color: 'var(--rm-muted)', marginTop: 8 }}>
            DepGuard heeft {FEATURE_MATRIX.filter(r => r.depguard === true && !r.dt && !r.snyk && !r.bd).length} unieke features die geen enkele concurrent bundelt.
          </p>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: Gaps & Status
      ════════════════════════════════════════════════════════════ */}
      {tab === 'gaps' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">🎯 Enterprise gaps — status overzicht</div>
            <p className="rm-section-desc">
              De grootste productgaten zitten nu niet meer in CRA, malware, SLSA of basis-reachability.
              <strong style={{ color: '#10b981' }}> De kernworkflow is live</strong>; schaalbaarheid, identity-hardening en bredere enterprise integraties zijn nu de belangrijkste commerciële blockers.
            </p>
          </div>

          <div className="rm-gaps-grid">
            {/* Done */}
            <div>
              <div className="rm-gap-col-header" style={{ color: '#10b981' }}>
                <span>✅</span> Opgelost ({GAPS.done.length})
              </div>
              {GAPS.done.map(g => (
                <div key={g.label} className="rm-gap-card rm-gap-done">
                  <div className="rm-gap-card-title" style={{ color: '#10b981' }}>{g.label}</div>
                  <div className="rm-gap-card-impact">{g.impact}</div>
                </div>
              ))}
            </div>

            {/* Critical */}
            <div>
              <div className="rm-gap-col-header" style={{ color: 'var(--rm-red)' }}>
                <span>🔴</span> Kritiek ({GAPS.critical.length})
              </div>
              {GAPS.critical.map(g => (
                <div key={g.label} className="rm-gap-card rm-gap-critical">
                  <div className="rm-gap-card-title">{g.label}</div>
                  <div className="rm-gap-card-impact">{g.impact}</div>
                </div>
              ))}
            </div>

            {/* High */}
            <div>
              <div className="rm-gap-col-header" style={{ color: 'var(--rm-amber)' }}>
                <span>🟠</span> Hoog ({GAPS.high.length})
              </div>
              {GAPS.high.map(g => (
                <div key={g.label} className="rm-gap-card rm-gap-high">
                  <div className="rm-gap-card-title">{g.label}</div>
                  <div className="rm-gap-card-impact">{g.impact}</div>
                </div>
              ))}
            </div>

            {/* Medium */}
            <div>
              <div className="rm-gap-col-header" style={{ color: 'var(--rm-blue)' }}>
                <span>🟡</span> Medium ({GAPS.medium.length})
              </div>
              {GAPS.medium.map(g => (
                <div key={g.label} className="rm-gap-card rm-gap-medium">
                  <div className="rm-gap-card-title">{g.label}</div>
                  <div className="rm-gap-card-impact">{g.impact}</div>
                </div>
              ))}
            </div>
            <div className="rm-gap-group">
              <div className="rm-gap-group-label">
                <span>📣</span> Go-to-Market / Content ({GAPS.gtm.length})
              </div>
              {GAPS.gtm.map(g => (
                <div key={g.label} className="rm-gap-card" style={{ borderLeft: '3px solid #8b5cf6' }}>
                  <div className="rm-gap-card-title">{g.label}</div>
                  <div className="rm-gap-card-impact">{g.impact}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: Roadmap
      ════════════════════════════════════════════════════════════ */}
      {tab === 'roadmap' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">🗺️ Implementatie roadmap — 6 maanden naar launch</div>
            <p className="rm-section-desc">Vijf fases van enterprise-ready naar eerste recurring revenue. Fase 1 is voltooid; fase 2 is inhoudelijk grotendeels live, met de AI-agent nog open.</p>
          </div>

          {/* Phase nodes timeline */}
          <div className="rm-timeline">
            <div className="rm-timeline-track">
              <div className="rm-timeline-connector" />
              {ROADMAP_PHASES.map(p => (
                <div key={p.num} className="rm-phase-node">
                  <div className={`rm-phase-ring ${p.status}`}>{p.num}</div>
                  <div className="rm-phase-name">{p.label}</div>
                  <div className="rm-phase-period">{p.period}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Phase detail cards */}
          <div className="rm-phase-cards">
            {ROADMAP_PHASES.map(p => (
              <div key={p.num} className="rm-phase-card">
                <div className={`rm-phase-card-header ${p.status}`}>
                  <div className={`rm-phase-num ${p.status}`}>{p.num}</div>
                  <div>
                    <div className="rm-phase-card-title">{p.label}</div>
                    <div className="rm-phase-card-sub">{p.period}</div>
                  </div>
                </div>
                <div className="rm-phase-card-body">
                  <ul className="rm-checklist">
                    {p.items.map(item => (
                      <li key={item.text} className={item.done ? 'done-item' : item.partial ? 'partial-item' : item.planned ? 'planned-item' : ''}>
                        <span>{item.done ? '✓' : item.partial ? '⏳' : item.planned ? '🔧' : '○'}</span>
                        <span>
                          {item.text}
                          {item.planned && <span className="rm-planned-badge">to be implemented</span>}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <div className={`rm-phase-outcome ${p.status}`}>
                    🎯 {p.outcome}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: Pricing
      ════════════════════════════════════════════════════════════ */}
      {tab === 'pricing' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">💶 Aanbevolen prijsmodel</div>
            <p className="rm-section-desc">
              <strong>Open Core</strong> — community editie voor adoptie en GitHub stars,
              betaalde tiers voor enterprise features en support. Bewezen model: HashiCorp Vault, Grafana, GitLab.
            </p>
          </div>

          <div className="rm-pricing-grid">
            {PRICING_TIERS.map(tier => (
              <div key={tier.name} className={`rm-pricing-card${tier.highlight ? ' highlight' : ''}`}>
                <div className="rm-pricing-header">
                  <div className="rm-pricing-name">{tier.name}</div>
                  <div className="rm-pricing-price">
                    {tier.price}
                    {tier.sub && <sub>{tier.sub}</sub>}
                  </div>
                  <div className="rm-pricing-desc">
                    {tier.name === 'Community' && 'Self-hosted · Open source · MIT'}
                    {tier.name === 'Starter' && 'SaaS · Per organisatie'}
                    {tier.name === 'Professional' && 'SaaS · Meest gekozen'}
                    {tier.name === 'Enterprise' && 'On-premise of SaaS · Custom'}
                  </div>
                </div>
                <ul className="rm-pricing-features">
                  {tier.features.map(f => <li key={f}>{f}</li>)}
                </ul>
                <div className="rm-pricing-cta">
                  <button className={tier.highlight ? 'rm-btn rm-btn-primary' : 'rm-btn rm-btn-outline'}>
                    {tier.name === 'Community' ? 'Download gratis' : tier.name === 'Enterprise' ? 'Neem contact op' : 'Start trial'}
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="rm-card" style={{ borderColor: 'rgba(245,158,11,0.2)', background: 'rgba(245,158,11,0.04)' }}>
            <div className="rm-strat-card-title">💡 Early adopter strategie</div>
            <p className="rm-section-desc" style={{ margin: 0 }}>
              Eerste 90 dagen geen pricing enforcement — focus op adoptie en feedback.
              <strong style={{ color: 'var(--rm-amber)' }}> Pilot pricing:</strong> eerste 10 klanten krijgen Professional voor €99/maand (lifetime early adopter deal).
              Dit genereert referenties, case studies en eerste MRR zonder sales-weerstand.
            </p>
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: Strategie
      ════════════════════════════════════════════════════════════ */}
      {tab === 'strategy' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">🚀 Go-to-market strategie</div>
            <p className="rm-section-desc">Van technisch product naar betaalde klanten in 6 maanden — de snelste route naar eerste recurring revenue.</p>
          </div>

          {/* KPI targets */}
          <div className="rm-strategy-kpi" style={{ marginBottom: 24 }}>
            {[
              { val: '€5K', label: 'MRR target M6',     color: '#10b981' },
              { val: '5',   label: 'Pilot klanten',      color: '#3b82f6' },
              { val: '500+',label: 'GitHub stars M3',    color: '#a855f7' },
              { val: '10m', label: 'Demo to sold cycle',  color: '#f59e0b' },
              { val: '€249',label: 'Avg MRR/klant',      color: '#10b981' },
              { val: '2027',label: 'EU CRA deadline',     color: '#ef4444' },
            ].map(k => (
              <div key={k.label} className="rm-kpi-card">
                <div className="rm-kpi-val" style={{ color: k.color }}>{k.val}</div>
                <div className="rm-kpi-label">{k.label}</div>
              </div>
            ))}
          </div>

          {/* Killer demo flow */}
          <div className="rm-card" style={{ borderColor: 'rgba(16,185,129,0.2)', background: 'rgba(16,185,129,0.04)', marginBottom: 24 }}>
            <div className="rm-strat-card-title">🎬 Killer demo — "Van SBOM naar audit-bewijs in 10 minuten"</div>
            <p className="rm-section-desc" style={{ marginBottom: 14 }}>
              Dit is de demo die enterprise-deals sluit. Europees MKB onder ISO27001 of EU CRA-druk ziet in 10 minuten precies welke NIST-controls zij schenden.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
              {[
                { step: '1', text: 'Upload SBOM', sub: '5 minuten', color: '#3b82f6' },
                { step: '2', text: 'Bekijk NTIA + CVEs', sub: 'Direct overzicht', color: '#f59e0b' },
                { step: '3', text: 'Open EU CRA mapping', sub: 'Welke controls?', color: '#ef4444' },
                { step: '4', text: 'Download PDF rapport', sub: 'Audit-bewijs klaar', color: '#10b981' },
              ].map(s => (
                <div key={s.step} style={{
                  background: `${s.color}12`, border: `1px solid ${s.color}30`,
                  borderRadius: 10, padding: '12px 14px', textAlign: 'center',
                }}>
                  <div style={{ fontSize: '1.4rem', fontWeight: 900, color: s.color, lineHeight: 1 }}>Stap {s.step}</div>
                  <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--rm-text)', margin: '4px 0 2px' }}>{s.text}</div>
                  <div style={{ fontSize: '0.72rem', color: 'var(--rm-muted)' }}>{s.sub}</div>
                </div>
              ))}
            </div>
            <p style={{ fontSize: '0.82rem', color: 'var(--rm-muted)', marginTop: 14, marginBottom: 0, lineHeight: 1.6 }}>
              💡 De klant betaalt niet voor features — hij betaalt voor de <em>vermeden boete</em> en de <em>bespaarde audit-tijd</em>.
              EU CRA-boetes tot €15M maken een Professional abonnement van €249/maand een no-brainer ROI.
            </p>
          </div>

          {/* GTM timeline */}
          <div className="rm-section-intro">
            <div className="rm-section-heading">📅 Go-to-market tijdlijn</div>
          </div>
          <div className="rm-card" style={{ padding: 0, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.83rem' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--rm-border-2)' }}>
                  {['Periode', 'Actie', 'Doel'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.8px', textTransform: 'uppercase', color: 'var(--rm-muted)', background: 'var(--rm-surface)' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  { period: 'M1–2', action: 'Auth + RBAC + Audit log ✅', doel: 'Enterprise-demo mogelijk ✅' },
                  { period: 'M1–2', action: 'UX overhaul: Inter font, ⌘K, collapsible sidebar ✅', doel: 'Professional look & feel ✅' },
                  { period: 'M2',   action: 'GitHub Actions CI/CD wizard (6 ecosystems) ✅', doel: 'Developer adoption out-of-the-box ✅' },
                  { period: 'M2–3', action: 'Webhook / Slack alerts (Slack, Teams, HTTP) ✅', doel: 'Push notificaties bij kritieke CVEs ✅' },
                  { period: 'M3',   action: 'Open Core repo op GitHub + Show HN post', doel: '500+ GitHub stars, 1000+ bezoekers' },
                  { period: 'M3–4', action: 'LinkedIn thought leadership (EU CRA serie)', doel: 'Inbound leads van compliance teams' },
                  { period: 'M4',   action: 'Eerste 5 pilot klanten benaderen (€99 early adopter)', doel: 'Eerste MRR + feedback loop' },
                  { period: 'M5',   action: 'Case study van pilot klant publiceren', doel: 'Social proof voor volgende deals' },
                  { period: 'M6',   action: 'Officiële SaaS launch + pricing page live', doel: '€5K–€10K MRR target' },
                ].map((row, i) => (
                  <tr key={`${row.period}-${i}`} style={{ borderBottom: i < 8 ? '1px solid var(--rm-border)' : 'none' }}>
                    <td style={{ padding: '10px 16px', fontFamily: 'monospace', fontWeight: 700, color: 'var(--rm-blue)', whiteSpace: 'nowrap' }}>{row.period}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--rm-text)' }}>{row.action}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--rm-muted)' }}>{row.doel}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="rm-card" style={{ borderColor: 'rgba(239,68,68,0.2)', background: 'rgba(239,68,68,0.04)', marginTop: 16 }}>
            <div className="rm-strat-card-title" style={{ color: 'var(--rm-red)' }}>⚠️ Kritische succesfactor</div>
            <p className="rm-section-desc" style={{ margin: 0 }}>
              DepGuard moet gepositioneerd worden als <strong style={{ color: 'var(--rm-text)' }}>compliance accelerator</strong>,
              niet als "nog een vulnerability scanner". De boodschap is:
              <strong style={{ color: 'var(--rm-blue)' }}> "Van SBOM naar audit-bewijs in 10 minuten."</strong>
              Dit differentieert van Snyk (developer-gericht) en Black Duck (te complex/duur).
            </p>
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: PACE Methodology
      ════════════════════════════════════════════════════════════ */}
      {tab === 'pace' && (
        <div className="rm-section-content">

          {/* ── PACE intro ── */}
          <div className="rm-section-intro">
            <div className="rm-section-heading">🔬 PACE — ING's Structured Innovation Process</div>
            <p className="rm-section-desc">
              PACE combineert <strong>Design Thinking</strong>, <strong>Lean Startup</strong> en <strong>Agile Scrum</strong> tot één gestructureerd innovatieproces.
              Dit overzicht toont hoe DepGuard zich verhoudt tot de 5 PACE-fasen en waar we nu staan.
            </p>
          </div>

          {/* ── Current phase badge ── */}
          <div style={{
            background: 'linear-gradient(135deg, rgba(59,130,246,0.12), rgba(16,185,129,0.08))',
            border: '1px solid rgba(59,130,246,0.3)',
            borderRadius: 14, padding: '18px 24px', marginBottom: 28,
            display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap',
          }}>
            <div style={{ fontSize: '2.5rem' }}>🔬</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', color: '#3b82f6', marginBottom: 4 }}>Huidige PACE fase</div>
              <div style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--rm-text)', marginBottom: 4 }}>Fase 3 — Solution Fit</div>
              <div style={{ fontSize: '0.82rem', color: 'var(--rm-muted)', lineHeight: 1.6 }}>
                DepGuard heeft Discover en Problem Fit succesvol afgerond. We valideren nu of onze oplossing groot genoeg is dat klanten "very disappointed" zouden zijn zonder DepGuard. Doel: first paying pilots, bewijs van PMF.
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: 900, color: '#3b82f6' }}>3/5</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--rm-muted)' }}>PACE fasen</div>
            </div>
          </div>

          {/* ── Three lenses ── */}
          <div className="rm-section-intro">
            <div className="rm-section-heading">🔍 De drie lenzen van PACE</div>
            <p className="rm-section-desc">Elke innovatie wordt beoordeeld op drie dimensies — een oplossing is alleen levensvatbaar als alle drie kloppen.</p>
          </div>
          <div className="rm-card-grid" style={{ marginBottom: 28 }}>
            {PACE_LENSES.map(lens => {
              const color = lens.score >= 7 ? '#10b981' : lens.score >= 5 ? '#3b82f6' : '#f59e0b';
              return (
                <div key={lens.id} className="rm-card" style={{ borderColor: `${lens.color}30` }}>
                  <div className="rm-card-icon-row" style={{ marginBottom: 10 }}>
                    <span className="rm-card-icon" style={{ background: `${lens.color}18`, fontSize: '1.5rem' }}>{lens.icon}</span>
                    <div>
                      <div className="rm-card-title" style={{ color: lens.color }}>{lens.label}</div>
                      <div className="rm-card-sub">{lens.sub}</div>
                    </div>
                    <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                      <div style={{ fontSize: '1.4rem', fontWeight: 900, color }}>{lens.score}<span style={{ fontSize: '0.75rem', opacity: 0.6 }}>/10</span></div>
                    </div>
                  </div>
                  <p className="rm-card-body" style={{ marginBottom: 10 }}><em>{lens.desc}</em></p>
                  <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
                    {lens.depguard.map((d, i) => (
                      <li key={i} style={{ fontSize: '0.78rem', color: 'var(--rm-muted)', lineHeight: 1.6, marginBottom: 2 }}>{d}</li>
                    ))}
                  </ul>
                  <div style={{ marginTop: 12 }}>
                    <div style={{ height: 6, borderRadius: 99, background: 'var(--rm-border-2)', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${lens.score * 10}%`, background: color, borderRadius: 99, transition: 'width 1s ease' }} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ── PACE phases ── */}
          <div className="rm-section-intro">
            <div className="rm-section-heading">📐 De 5 PACE-fasen — DepGuard journey</div>
            <p className="rm-section-desc">Van eerste discovery naar schaalbare commercialisering. Iedere fase heeft een exit-criterium dat bewezen moet zijn voordat door te gaan.</p>
          </div>

          {/* Phase timeline track */}
          <div className="rm-timeline" style={{ marginBottom: 28 }}>
            <div className="rm-timeline-track">
              <div className="rm-timeline-connector" />
              {PACE_PHASES.map(p => (
                <div key={p.num} className="rm-phase-node">
                  <div className={`rm-phase-ring ${p.status}`}>{p.icon}</div>
                  <div className="rm-phase-name" style={{ fontSize: '0.7rem' }}>{p.label}</div>
                  <div className="rm-phase-period">{p.period}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Phase detail cards */}
          <div style={{ display: 'grid', gap: 18, marginBottom: 28 }}>
            {PACE_PHASES.map(p => {
              const statusColor = p.status === 'done' ? '#10b981' : p.status === 'active' ? '#3b82f6' : 'var(--rm-muted)';
              const statusLabel = p.status === 'done' ? '✅ Afgerond' : p.status === 'active' ? '🔵 Actief' : '⬜ Gepland';
              return (
                <div key={p.num} className="rm-card" style={{
                  borderColor: p.status === 'active' ? 'rgba(59,130,246,0.4)' : p.status === 'done' ? 'rgba(16,185,129,0.2)' : 'var(--rm-border)',
                  background: p.status === 'active' ? 'rgba(59,130,246,0.04)' : undefined,
                }}>
                  {/* Header */}
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 14, flexWrap: 'wrap' }}>
                    <div style={{
                      width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                      background: p.status === 'done' ? 'rgba(16,185,129,0.15)' : p.status === 'active' ? 'rgba(59,130,246,0.15)' : 'var(--rm-surface-2)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem',
                    }}>{p.icon}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 2 }}>
                        <span style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: 'var(--rm-muted)' }}>Fase {p.num}</span>
                        <span style={{ fontSize: '0.72rem', fontWeight: 700, padding: '2px 8px', borderRadius: 99, background: `${statusColor}18`, color: statusColor }}>{statusLabel}</span>
                        <span style={{ fontSize: '0.72rem', color: 'var(--rm-muted)' }}>{p.period}</span>
                      </div>
                      <div style={{ fontSize: '1.05rem', fontWeight: 800, color: 'var(--rm-text)' }}>{p.label}</div>
                      <div style={{ fontSize: '0.78rem', color: 'var(--rm-muted)' }}>{p.sub}</div>
                    </div>
                    {/* Exit criteria badge */}
                    <div style={{
                      flexShrink: 0, padding: '6px 12px', borderRadius: 8,
                      background: p.exitMet ? 'rgba(16,185,129,0.1)' : p.status === 'active' ? 'rgba(59,130,246,0.1)' : 'var(--rm-surface-2)',
                      border: `1px solid ${p.exitMet ? 'rgba(16,185,129,0.3)' : 'var(--rm-border)'}`,
                      textAlign: 'center',
                    }}>
                      <div style={{ fontSize: '1.1rem' }}>{p.exitMet ? '✅' : p.status === 'active' ? '🔄' : '⏳'}</div>
                      <div style={{ fontSize: '0.65rem', color: 'var(--rm-muted)', marginTop: 2 }}>Exit {p.exitMet ? 'behaald' : p.status === 'active' ? 'in progress' : 'gepland'}</div>
                    </div>
                  </div>

                  <p style={{ fontSize: '0.83rem', color: 'var(--rm-muted)', lineHeight: 1.6, marginBottom: 14 }}>{p.description}</p>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 14 }}>

                    {/* Key questions */}
                    <div>
                      <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: 'var(--rm-muted)', marginBottom: 8 }}>🤔 Kernvragen</div>
                      <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
                        {p.questions.map((q, i) => (
                          <li key={i} style={{ fontSize: '0.78rem', color: 'var(--rm-text)', lineHeight: 1.65, marginBottom: 3 }}>{q}</li>
                        ))}
                      </ul>
                    </div>

                    {/* Learnings or planned experiments */}
                    {p.keyLearnings && p.keyLearnings.length > 0 ? (
                      <div>
                        <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: '#10b981', marginBottom: 8 }}>💡 Key Learnings</div>
                        <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
                          {p.keyLearnings.map((l, i) => (
                            <li key={i} style={{ fontSize: '0.78rem', color: 'var(--rm-text)', lineHeight: 1.65, marginBottom: 3 }}>{l}</li>
                          ))}
                        </ul>
                      </div>
                    ) : p.plannedExperiments ? (
                      <div>
                        <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: '#f59e0b', marginBottom: 8 }}>🧪 Geplande experimenten</div>
                        <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
                          {p.plannedExperiments.map((e, i) => (
                            <li key={i} style={{ fontSize: '0.78rem', color: 'var(--rm-text)', lineHeight: 1.65, marginBottom: 3 }}>{e}</li>
                          ))}
                        </ul>
                      </div>
                    ) : null}

                    {/* Assumptions */}
                    <div>
                      <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: 'var(--rm-muted)', marginBottom: 8 }}>📌 Aannames</div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                        {p.assumptions.map((a, i) => (
                          <div key={i} style={{
                            display: 'flex', gap: 8, alignItems: 'flex-start',
                            padding: '5px 8px', borderRadius: 6,
                            background: a.validated === true ? 'rgba(16,185,129,0.08)' : a.validated === false ? 'rgba(239,68,68,0.08)' : 'var(--rm-surface-2)',
                          }}>
                            <span style={{ flexShrink: 0, fontSize: '0.75rem' }}>
                              {a.validated === true ? '✅' : a.validated === false ? '❌' : '❓'}
                            </span>
                            <span style={{ fontSize: '0.75rem', color: 'var(--rm-text)', lineHeight: 1.5 }}>{a.text}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Current experiment spotlight */}
                  {p.currentExperiment && (
                    <div style={{
                      marginTop: 16, padding: '14px 16px', borderRadius: 10,
                      background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.2)',
                    }}>
                      <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.7px', textTransform: 'uppercase', color: '#3b82f6', marginBottom: 10 }}>🧪 Lopend experiment</div>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 10 }}>
                        {[
                          { label: 'Hypothese', val: p.currentExperiment.hypothesis },
                          { label: 'Methode', val: p.currentExperiment.method },
                          { label: 'Succes-metric', val: p.currentExperiment.metric },
                        ].map(item => (
                          <div key={item.label}>
                            <div style={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--rm-muted)', textTransform: 'uppercase', marginBottom: 3 }}>{item.label}</div>
                            <div style={{ fontSize: '0.78rem', color: 'var(--rm-text)', lineHeight: 1.5 }}>{item.val}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Exit criteria */}
                  <div style={{
                    marginTop: 14, padding: '8px 12px', borderRadius: 8,
                    background: p.exitMet ? 'rgba(16,185,129,0.08)' : 'var(--rm-surface-2)',
                    border: `1px solid ${p.exitMet ? 'rgba(16,185,129,0.25)' : 'var(--rm-border)'}`,
                    fontSize: '0.75rem', color: p.exitMet ? '#10b981' : 'var(--rm-muted)',
                  }}>
                    <strong>Exit criterium:</strong> {p.exitCriteria}
                    {p.canvas && p.canvas.length > 0 && (
                      <span style={{ marginLeft: 12, opacity: 0.7 }}>📋 {p.canvas.join(' · ')}</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* ── Experiment Loop ── */}
          <div className="rm-section-intro">
            <div className="rm-section-heading">🔄 PACE Experiment Loop — huidige fase</div>
            <p className="rm-section-desc">Binnen elke PACE-fase draaien continue experiment-loops om aannames te valideren. Dit is de actieve loop voor Solution Fit.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 28 }}>
            {PACE_EXPERIMENT_LOOP.map((s, i) => (
              <div key={s.step} style={{
                background: 'var(--rm-surface-2)', border: '1px solid var(--rm-border)',
                borderRadius: 12, padding: '14px 16px', position: 'relative',
                borderTop: `3px solid ${i === 4 ? '#a855f7' : i === 3 ? '#10b981' : '#3b82f6'}`,
              }}>
                <div style={{ fontSize: '1.6rem', marginBottom: 8 }}>{s.icon}</div>
                <div style={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--rm-muted)', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: 4 }}>Stap {s.step}</div>
                <div style={{ fontSize: '0.82rem', fontWeight: 700, color: 'var(--rm-text)', marginBottom: 6 }}>{s.label}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--rm-muted)', lineHeight: 1.55 }}>{s.desc}</div>
                {i < PACE_EXPERIMENT_LOOP.length - 1 && (
                  <div style={{
                    position: 'absolute', right: -10, top: '50%', transform: 'translateY(-50%)',
                    fontSize: '0.9rem', color: 'var(--rm-muted)', zIndex: 1, display: 'none',
                  }}>→</div>
                )}
              </div>
            ))}
          </div>

          {/* ── Decision framework ── */}
          <div className="rm-card" style={{ borderColor: 'rgba(168,85,247,0.25)', background: 'rgba(168,85,247,0.04)' }}>
            <div className="rm-strat-card-title" style={{ color: '#a855f7' }}>🧭 PACE Evidence-based Besluitvorming</div>
            <p className="rm-section-desc" style={{ marginBottom: 16 }}>
              Na elk experiment beslist het team op basis van bewijs: <strong>Persevere, Pivot, Iterate of Stop</strong> — niet op basis van aannames of politiek.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10 }}>
              {[
                { icon: '▶️', label: 'Persevere', color: '#10b981', desc: 'Aanname gevalideerd — verdere investeringen in huidige richting' },
                { icon: '↪️', label: 'Pivot', color: '#3b82f6', desc: 'Aanname ongeldig — aanpassen richting op basis van klantlering' },
                { icon: '🔁', label: 'Iterate', color: '#f59e0b', desc: 'Gedeeltelijk gevalideerd — experiment verfijnen en opnieuw testen' },
                { icon: '⛔', label: 'Stop', color: '#ef4444', desc: 'Niet levensvatbaar aangetoond — resources vrijmaken voor andere kansen' },
              ].map(d => (
                <div key={d.label} style={{
                  background: `${d.color}10`, border: `1px solid ${d.color}25`,
                  borderRadius: 10, padding: '12px 14px',
                }}>
                  <div style={{ fontSize: '1.3rem', marginBottom: 6 }}>{d.icon}</div>
                  <div style={{ fontSize: '0.83rem', fontWeight: 700, color: d.color, marginBottom: 4 }}>{d.label}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--rm-muted)', lineHeight: 1.5 }}>{d.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Vigil + Reachability: PACE position ── */}
          <div className="rm-card" style={{ borderColor: 'rgba(16,185,129,0.25)', background: 'rgba(16,185,129,0.04)' }}>
            <div className="rm-strat-card-title" style={{ color: '#10b981' }}>🔬 Vigil & Reachability — Positie in PACE</div>
            <p className="rm-section-desc" style={{ marginBottom: 20 }}>
              Vigil (Joern CPG-scan engine) is de technische brug tussen DepGuard's SBOM-bevindingen en code-niveau bewijs.
              Kernvraag: <em>"Package X heeft een CVE — roept jouw code die kwetsbare functie ook écht aan?"</em>
              Dit is de <strong>Riskiest Assumption</strong> voor Solution Fit: willen klanten dit in DepGuard, of behouden ze SonarQube?
            </p>
            <p className="rm-section-desc" style={{ marginBottom: 20, color: 'var(--rm-muted)' }}>
              Het extra probleem: de meeste CVEs (~60%) geven <strong>geen code-locatie</strong> — alleen een versie-range.
              Vigil lost dit op met 6 complementaire tiers die ook zonder exacte functielocatie werken.
            </p>

            <div style={{ fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', color: '#10b981', marginBottom: 12 }}>
              6-tier reachability pipeline — ook als CVE geen code-locatie geeft
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginBottom: 24 }}>
              {[
                {
                  tier: 'Tier 1', icon: '🔩', color: '#10b981', coverage: '~40% CVEs',
                  label: 'Fix-commit extractie',
                  desc: 'OSV/GHSA linkt bijna altijd de patch-commit. Diff toont welke functies gewijzigd zijn → Joern traceert of jouw code die functies aanroept.',
                  example: 'CVE-2021-44228 → log4j commit → JndiManager.lookup() gewijzigd → Joern: cpg.call.name("lookup")…',
                },
                {
                  tier: 'Tier 2', icon: '🗂️', color: '#3b82f6', coverage: '~65% CVEs',
                  label: 'CWE → Vigil-regelkoppeling',
                  desc: 'Elke CVE heeft een CWE (type zwakheid). CWE is een directe brug naar Vigil\'s bestaande regelset — geen exacte code-locatie nodig.',
                  example: 'CWE-89 → SQL Injection rules · CWE-79 → XSS rules · CWE-502 → Deserialization rules',
                },
                {
                  tier: 'Tier 3', icon: '🤖', color: '#a855f7', coverage: '~85% CVEs',
                  label: 'AI-gegenereerde Joern query',
                  desc: 'CVE-beschrijving → DepGuard AI → Joern-query op maat. LLM leidt af welke API-patronen riskant zijn, geen handmatige mapping vereist.',
                  example: '"Log4j verwerkt user-input in log-berichten" → cpg.call.name("(info|debug|error)").whereNot(_.argument.isLiteral)',
                },
                {
                  tier: 'Tier 4', icon: '📊', color: '#f59e0b', coverage: '100% CVEs',
                  label: 'Call-site exposure score',
                  desc: 'Altijd toepasbaar. Telt hoe vaak jouw code het kwetsbare pakket aanroept × CVSS-score = prioriteitsranking zonder code-locatie.',
                  example: 'lodash CVE CVSS 7.2 × 14 aanroepsites = exposure 101 → prioriteit HIGH',
                },
                {
                  tier: 'Tier 5', icon: '🔎', color: '#ec4899', coverage: 'Java codebases',
                  label: 'Joern CPG Java analyzer',
                  desc: 'Joern Code Property Graph analyse voor Java. Echte CPG-queries voor aanroepbaarheid; vervangt de gebroken SootUp-brug — direct geïntegreerd in de pipeline.',
                  example: 'pkg:maven/log4j → Joern CPG traversal → JndiManager.lookup() aanroepbaar ✅',
                },
                {
                  tier: 'Tier 6', icon: '🔴', color: '#ef4444', coverage: 'OWASP top-10',
                  label: 'Semgrep CVE pattern matching',
                  desc: '3 matching-strategieën: CVE ID exact → CWE ID → pakket-naam tokens in regel-ID. Draait --config p/owasp-top-ten per repo concurrent als fallback na Tier 3.',
                  example: 'WebGoat 128.4% ✅ · NodeGoat 81.6% ✅ · juice-shop 77.4% 🔜 · railsgoat 22.4% 🔜',
                },
              ].map(t => (
                <div key={t.tier} style={{
                  background: `${t.color}0d`, border: `1px solid ${t.color}30`,
                  borderRadius: 10, padding: '14px 16px',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <span style={{ fontSize: '1.1rem' }}>{t.icon}</span>
                    <span style={{ fontWeight: 700, color: t.color, fontSize: '0.82rem' }}>{t.tier} — {t.label}</span>
                    <span style={{
                      marginLeft: 'auto', fontSize: '0.65rem', fontWeight: 700,
                      background: `${t.color}20`, color: t.color,
                      borderRadius: 20, padding: '2px 8px', whiteSpace: 'nowrap',
                    }}>{t.coverage}</span>
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--rm-muted)', lineHeight: 1.6, marginBottom: 8 }}>{t.desc}</div>
                  <div style={{ fontSize: '0.69rem', fontFamily: 'monospace', color: t.color, background: `${t.color}08`, borderRadius: 6, padding: '6px 10px', lineHeight: 1.5 }}>{t.example}</div>
                </div>
              ))}
            </div>

            <div style={{ fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', color: '#10b981', marginBottom: 12 }}>
              PACE beslissingsmatrix — Vigil na Solution Fit validatie
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 10 }}>
              {[
                { icon: '▶️', label: 'Persevere', color: '#10b981', condition: 'Klant noemt reachability als koopbeslissing', result: 'Tier 1+2 productie-ready bouwen; Vigil wordt core feature' },
                { icon: '↪️', label: 'Pivot', color: '#3b82f6', condition: 'Klant wil reachability maar niet full SAST', result: 'Vigil = Tier 2 (CWE→rule) + exposure score; Rule Studio op achtergrond' },
                { icon: '🔁', label: 'Iterate', color: '#f59e0b', condition: 'Concept interessant, maar waarde nog niet duidelijk', result: 'Demo met echte CVE → 3 aanroepbare findings in 2 minuten verbeteren' },
                { icon: '⛔', label: 'Stop Vigil', color: '#ef4444', condition: 'Geen klant vermeldt reachability als reden', result: 'Vigil = intern tooling; SBOM-focus blijft primair voor DepGuard' },
              ].map(d => (
                <div key={d.label} style={{
                  background: `${d.color}0d`, border: `1px solid ${d.color}25`,
                  borderRadius: 10, padding: '12px 14px',
                }}>
                  <div style={{ fontSize: '1.1rem', marginBottom: 5 }}>{d.icon}</div>
                  <div style={{ fontSize: '0.82rem', fontWeight: 700, color: d.color, marginBottom: 4 }}>{d.label}</div>
                  <div style={{ fontSize: '0.72rem', color: 'var(--rm-muted)', lineHeight: 1.5, marginBottom: 6 }}>
                    <strong style={{ color: 'var(--rm-text)' }}>Conditie:</strong> {d.condition}
                  </div>
                  <div style={{ fontSize: '0.72rem', color: 'var(--rm-muted)', lineHeight: 1.5 }}>
                    <strong style={{ color: 'var(--rm-text)' }}>Actie:</strong> {d.result}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      )}

      {/* ════════════════════════════════════════════════════════════
          Tab: Look & Feel / UX Design Plan
      ════════════════════════════════════════════════════════════ */}
      {tab === 'ux' && (
        <div className="rm-section-content">
          <div className="rm-section-intro">
            <div className="rm-section-heading">🎨 Look & Feel — UX Design Strategie voor DepGuard</div>
            <p className="rm-section-desc">
              Een diepgaande analyse van welk design-systeem, visuele identiteit en UX-patronen het beste passen
              bij DepGuard als commercieel security platform — en wat er concreet verbeterd moet worden.
            </p>
          </div>

          {/* ── 1. Design identiteit ── */}
          <div className="rm-card" style={{ marginBottom: 20 }}>
            <div className="rm-strat-card-title">🧭 1. Design Identiteit — "Dark Security Intelligence"</div>
            <p className="rm-section-desc" style={{ marginBottom: 14 }}>
              DepGuard's doelgroep (CISOs, DevSecOps engineers, compliance teams) werkt primair in donkere omgevingen —
              terminals, IDEs, security dashboards. De visuele identiteit moet <strong style={{ color: 'var(--rm-text)' }}>vertrouwen, precisie en autoriteit</strong> uitstralen.
              Inspiratie: Linear, Vercel, Datadog, Grafana — niet: Jira, Confluence of generieke SaaS.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
              {[
                { icon: '🌑', title: 'Dark-first', desc: 'Dark mode is de primaire ervaring. Lichte variant als optie, nooit als default voor security tools.' },
                { icon: '🎯', title: 'Data-dense maar leesbaar', desc: 'Security data is complex. Het design moet veel informatie bevatten zonder overweldigend te voelen.' },
                { icon: '⚡', title: 'Snelle feedback', desc: 'Elke actie geeft directe visuele respons. Loading states, success/error feedback altijd zichtbaar.' },
                { icon: '🔒', title: 'Vertrouwen uitstralen', desc: 'Consistente patronen, geen verrassingen. Gebruikers moeten de tool vertrouwen met hun security data.' },
              ].map(p => (
                <div key={p.title} style={{ background: 'var(--rm-surface-2)', borderRadius: 8, padding: '12px 14px' }}>
                  <div style={{ fontSize: '1.4rem', marginBottom: 6 }}>{p.icon}</div>
                  <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--rm-text)', marginBottom: 4 }}>{p.title}</div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--rm-muted)', lineHeight: 1.5 }}>{p.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── 2. Kleurpalet ── */}
          <div className="rm-card" style={{ marginBottom: 20 }}>
            <div className="rm-strat-card-title">🎨 2. Aanbevolen Kleurpalet</div>
            <p className="rm-section-desc" style={{ marginBottom: 16 }}>
              Eén sterk primair accent (blauw = vertrouwen + technologie) met semantische kleurcodering voor security-statussen.
              Geen regenboog-dashboards — kleuren hebben betekenis.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
              {[
                { color: '#0f172a', label: 'Achtergrond', hex: '#0f172a', role: 'Primaire achtergrond (dark)' },
                { color: '#1e293b', label: 'Surface', hex: '#1e293b', role: 'Kaarten, panels, modals' },
                { color: '#334155', label: 'Border', hex: '#334155', role: 'Scheidingslijnen, randen' },
                { color: '#3b82f6', label: 'Primair accent', hex: '#3b82f6', role: 'CTA, actieve states, links' },
                { color: '#10b981', label: 'Succes / Veilig', hex: '#10b981', role: 'Geen kwetsbaarheden, opgelost' },
                { color: '#f59e0b', label: 'Waarschuwing', hex: '#f59e0b', role: 'Medium CVEs, deprecated' },
                { color: '#ef4444', label: 'Kritiek', hex: '#ef4444', role: 'Critical CVEs, policy fail' },
                { color: '#a855f7', label: 'Premium / AI', hex: '#a855f7', role: 'AI features, enterprise badges' },
              ].map(c => (
                <div key={c.label} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'var(--rm-surface-2)', borderRadius: 8, padding: '8px 12px', minWidth: 200 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 6, background: c.color, flexShrink: 0, border: '1px solid rgba(255,255,255,0.1)' }} />
                  <div>
                    <div style={{ fontSize: '0.82rem', fontWeight: 700, color: 'var(--rm-text)' }}>{c.label}</div>
                    <div style={{ fontSize: '0.7rem', fontFamily: 'monospace', color: 'var(--rm-muted)' }}>{c.hex}</div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--rm-muted)' }}>{c.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── 3. Typografie ── */}
          <div className="rm-card" style={{ marginBottom: 20 }}>
            <div className="rm-strat-card-title">🔤 3. Typografie</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <p className="rm-section-desc" style={{ marginBottom: 12 }}>
                  <strong style={{ color: 'var(--rm-text)' }}>Aanbevolen font:</strong> <code style={{ color: 'var(--rm-blue)' }}>Inter</code> (of system-ui als fallback).
                  Inter is ontworpen voor schermen, uitstekend leesbaar bij kleine groottes en heeft een professionele, neutrale uitstraling die past bij enterprise SaaS.
                </p>
                <ul className="rm-strat-list">
                  <li><span>→</span><span><strong style={{ color: 'var(--rm-text)' }}>H1 / Page titles:</strong> 1.75rem, weight 800, letter-spacing -0.5px</span></li>
                  <li><span>→</span><span><strong style={{ color: 'var(--rm-text)' }}>H2 / Section headers:</strong> 1.1rem, weight 700</span></li>
                  <li><span>→</span><span><strong style={{ color: 'var(--rm-text)' }}>Body:</strong> 0.875rem, weight 400, line-height 1.6</span></li>
                  <li><span>→</span><span><strong style={{ color: 'var(--rm-text)' }}>Labels / metadata:</strong> 0.72rem, weight 600, UPPERCASE, letter-spacing 0.5px</span></li>
                  <li><span>→</span><span><strong style={{ color: 'var(--rm-text)' }}>Code / hashes:</strong> JetBrains Mono of Fira Code, 0.82rem</span></li>
                </ul>
              </div>
              <div>
                <p className="rm-section-desc" style={{ marginBottom: 12 }}>
                  <strong style={{ color: 'var(--rm-text)' }}>Hiërarchie voorbeeld:</strong>
                </p>
                <div style={{ background: 'var(--rm-surface-2)', borderRadius: 8, padding: 16 }}>
                  <div style={{ fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-0.5px', color: 'var(--rm-text)', marginBottom: 4 }}>SBOM Analysis</div>
                  <div style={{ fontSize: '1rem', fontWeight: 700, color: 'var(--rm-text)', marginBottom: 8 }}>Vulnerability Overview</div>
                  <div style={{ fontSize: '0.875rem', color: 'var(--rm-muted)', lineHeight: 1.6, marginBottom: 10 }}>3 critical vulnerabilities found in 247 packages across 2 repositories.</div>
                  <div style={{ fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--rm-muted)' }}>Last scanned: 2 hours ago</div>
                  <div style={{ fontSize: '0.82rem', fontFamily: 'monospace', color: '#a855f7', marginTop: 4 }}>pkg:npm/lodash@4.17.20</div>
                </div>
              </div>
            </div>
          </div>

          {/* ── 4. Huidige UX problemen ── */}
          <div className="rm-card" style={{ marginBottom: 20 }}>
            <div className="rm-strat-card-title">🔍 4. Huidige UX Problemen — Eerlijke Audit</div>
            <p className="rm-section-desc" style={{ marginBottom: 14 }}>
              Wat er nu nog ontbreekt of verbeterd moet worden voor een commercieel overtuigend product.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 12 }}>
              {[
                { sev: 'hoog', color: '#ef4444', title: 'Geen onboarding flow', desc: 'Nieuwe gebruikers zien een leeg dashboard zonder uitleg. Een "First steps" wizard of interactieve tour is essentieel voor conversie.' },
                { sev: 'hoog', color: '#ef4444', title: 'Lege states ontbreken', desc: 'Lege tabellen/lijsten tonen niets. Een goede empty state met uitleg + call-to-action verhoogt activatie aanzienlijk.' },
                { sev: 'hoog', color: '#ef4444', title: 'Geen visuele brand identity', desc: 'Logo, favicon, og:image, brand colors zijn niet consistent. Voor enterprise-klanten is dit een vertrouwenssignaal.' },
                { sev: 'medium', color: '#f59e0b', title: 'Inconsistente component stijlen', desc: 'Mix van Bootstrap classes en custom CSS. Migratie naar een coherent design system (bv. Radix UI + Tailwind) aanbevolen.' },
                { sev: 'medium', color: '#f59e0b', title: 'Navigatie schaalt niet', desc: 'Bij 10+ menu-items wordt de sidebar onoverzichtelijk. Gegroepeerde navigatie met collapse/expand nodig.' },
                { sev: 'medium', color: '#f59e0b', title: 'Geen keyboard shortcuts', desc: 'Power users (DevSecOps engineers) verwachten sneltoetsen (⌘K search, j/k navigatie, etc.).' },
                { sev: 'laag', color: '#3b82f6', title: 'Animaties ontbreken', desc: 'Pagina-overgangen, loading skeletons, micro-animaties op hover verhogen de perceived quality significant.' },
                { sev: 'laag', color: '#3b82f6', title: 'Geen responsieve mobiele layout', desc: 'Dashboard is niet goed bruikbaar op tablet/mobiel. Belangrijk voor management die rapporten wil bekijken.' },
              ].map(p => (
                <div key={p.title} style={{ background: 'var(--rm-surface-2)', borderRadius: 8, padding: '12px 14px', borderLeft: `3px solid ${p.color}` }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                    <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--rm-text)' }}>{p.title}</div>
                    <span style={{ fontSize: '0.62rem', fontWeight: 700, padding: '2px 6px', borderRadius: 4, background: `${p.color}20`, color: p.color, textTransform: 'uppercase', flexShrink: 0, marginLeft: 8 }}>{p.sev}</span>
                  </div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--rm-muted)', lineHeight: 1.5 }}>{p.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── 5. UX Verbeterplan ── */}
          <div className="rm-card" style={{ marginBottom: 20 }}>
            <div className="rm-strat-card-title">🚀 5. UX Verbeterplan — Prioriteit volgorde</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0, borderRadius: 8, overflow: 'hidden', border: '1px solid var(--rm-border)' }}>
              {[
                { prio: 1, title: 'Onboarding wizard',           effort: 'M',  impact: 'Hoog', desc: '"Upload je eerste SBOM in 3 stappen" — direct na login, overslaan mogelijk. Verhoogt activatie van 20% naar 60%+.' },
                { prio: 2, title: 'Consistente brand identity',  effort: 'S',  impact: 'Hoog', desc: 'Professioneel logo (SVG), favicon, og:image, primaire kleur doorvoeren op alle pagina\'s. 1 dag werk, groot vertrouwenssignaal.' },
                { prio: 3, title: 'Lege states met CTAs',         effort: 'S',  impact: 'Hoog', desc: 'Elke lege tabel/lijst krijgt een illustratie + beschrijving + actie-knop. "Nog geen SBOMs — upload je eerste".' },
                { prio: 4, title: 'Loading skeletons',            effort: 'S',  impact: 'Med', desc: 'Vervang spinners door skeleton screens. Verbetert perceived performance drastisch.' },
                { prio: 5, title: 'Design system consolidatie',  effort: 'L',  impact: 'Med', desc: 'Kies één component library (aanbeveling: shadcn/ui + Tailwind). Verwijder Bootstrap geleidelijk. 1-2 sprints.' },
                { prio: 6, title: '⌘K command palette',          effort: 'M',  impact: 'Med', desc: 'Globale zoek/navigatie shortcut. Standaard verwachting bij developer-tools. Verhoogt engagement van power users.' },
                { prio: 7, title: 'Responsieve sidebar / mobile',effort: 'M',  impact: 'Laag', desc: 'Collapsible sidebar, touch-friendly tap targets. Belangrijk voor demo\'s op tablet.' },
              ].map((r, i) => (
                <div key={r.title} style={{ display: 'grid', gridTemplateColumns: '32px 1fr auto auto', gap: 12, alignItems: 'center', padding: '11px 14px', borderBottom: i < 6 ? '1px solid var(--rm-border)' : 'none', background: i % 2 === 0 ? 'transparent' : 'var(--rm-surface)' }}>
                  <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'var(--rm-surface-2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', fontWeight: 800, color: 'var(--rm-blue)' }}>{r.prio}</div>
                  <div>
                    <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--rm-text)', marginBottom: 2 }}>{r.title}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--rm-muted)', lineHeight: 1.4 }}>{r.desc}</div>
                  </div>
                  <span style={{ fontSize: '0.68rem', fontWeight: 700, padding: '2px 8px', borderRadius: 4, background: r.effort === 'S' ? 'rgba(16,185,129,0.12)' : r.effort === 'M' ? 'rgba(245,158,11,0.12)' : 'rgba(239,68,68,0.12)', color: r.effort === 'S' ? '#10b981' : r.effort === 'M' ? '#f59e0b' : '#ef4444', whiteSpace: 'nowrap' }}>
                    {r.effort === 'S' ? 'Klein' : r.effort === 'M' ? 'Middel' : 'Groot'}
                  </span>
                  <span style={{ fontSize: '0.68rem', fontWeight: 700, padding: '2px 8px', borderRadius: 4, background: r.impact === 'Hoog' ? 'rgba(59,130,246,0.12)' : 'rgba(100,116,139,0.12)', color: r.impact === 'Hoog' ? '#3b82f6' : '#64748b', whiteSpace: 'nowrap' }}>
                    {r.impact}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* ── 6. Design system aanbeveling ── */}
          <div className="rm-card" style={{ marginBottom: 20 }}>
            <div className="rm-strat-card-title">🧱 6. Aanbevolen Design System Stack</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
              {[
                { icon: '🎨', name: 'shadcn/ui', role: 'Component library', why: 'Copy-paste components, volledig customizable, geen lock-in. Standaard in modern React.' },
                { icon: '💨', name: 'Tailwind CSS', role: 'Utility CSS', why: 'Snelle iteratie, consistente spacing/kleuren, dark mode native. Bootstrap vervangen.' },
                { icon: '✨', name: 'Framer Motion', role: 'Animaties', why: 'Page transitions, micro-animations, loading states. Verhoogt perceived quality enorm.' },
                { icon: '📊', name: 'Recharts / Tremor', role: 'Data visualisatie', why: 'Vervangt Chart.js. Tremor heeft kant-en-klare dashboard componenten (score gauges, trend lines).' },
                { icon: '🔍', name: 'cmdk', role: 'Command palette', why: 'De standaard ⌘K library voor React. Linear, Vercel, Raycast gebruiken het allemaal.' },
                { icon: '🔔', name: 'Sonner', role: 'Toast notificaties', why: 'Vervangt huidige toasts. Mooier, animaties, promise-based API.' },
              ].map(s => (
                <div key={s.name} style={{ background: 'var(--rm-surface-2)', borderRadius: 8, padding: '12px 14px' }}>
                  <div style={{ fontSize: '1.3rem', marginBottom: 6 }}>{s.icon}</div>
                  <div style={{ fontSize: '0.88rem', fontWeight: 700, color: 'var(--rm-text)' }}>{s.name}</div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--rm-blue)', fontWeight: 600, marginBottom: 4 }}>{s.role}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--rm-muted)', lineHeight: 1.5 }}>{s.why}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── 7. Concurrenten design vergelijking ── */}
          <div className="rm-card">
            <div className="rm-strat-card-title">🔎 7. Design Benchmarks — Wat werkt bij concurrenten</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0, borderRadius: 8, overflow: 'hidden', border: '1px solid var(--rm-border)' }}>
              {[
                { product: 'Linear',      lesson: 'Dark-first, keyboard shortcuts, snelle navigatie — standard setter voor developer tools. Alles voelt instant.' },
                { product: 'Vercel',      lesson: 'Uitstekende typografie hiërarchie, status badges (Ready / Error / Building) zijn direct scanbaar. Deployment flows zijn intuïtief.' },
                { product: 'Datadog',     lesson: 'Data-density zonder chaos. Elk getal heeft context. Kleuren zijn semantisch — rood = probleem, groen = ok. Nooit decoratief.' },
                { product: 'Snyk',        lesson: 'Severity badges zijn industrie-standaard geworden. "Fix PR" CTA direct naast elke kwetsbaarheid. Actionable, niet alleen informatief.' },
                { product: 'Grafana',     lesson: 'Donker dashboard dat vol staat met data maar toch overzichtelijk is. Goed gebruik van spacing en groepering.' },
              ].map((r, i) => (
                <div key={r.product} style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: 12, alignItems: 'flex-start', padding: '11px 14px', borderBottom: i < 4 ? '1px solid var(--rm-border)' : 'none' }}>
                  <div style={{ fontSize: '0.82rem', fontWeight: 800, color: 'var(--rm-blue)', fontFamily: 'monospace' }}>{r.product}</div>
                  <div style={{ fontSize: '0.82rem', color: 'var(--rm-muted)', lineHeight: 1.5 }}>{r.lesson}</div>
                </div>
              ))}
            </div>
            <p style={{ fontSize: '0.78rem', color: 'var(--rm-muted)', marginTop: 14, marginBottom: 0, lineHeight: 1.6 }}>
              💡 <strong style={{ color: 'var(--rm-text)' }}>DepGuard's UX doel:</strong> Voelt als Datadog voor security engineers — niet als een intern CRUD-tool.
              Elk scherm moet de vraag beantwoorden: "Wat moet ik <em>nu</em> doen?"
            </p>
          </div>

        </div>
      )}

    </div>
  );
}
